export enum Shops {
  STREET_FOOD = 1,
  TO_GO = 2,
}
